<ng-container screenAnalytics="currency-configuration">
    <div class="modal-header no-icon">
        <h3 class="modal-title">Currency Requirements</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <knowledge-base-link></knowledge-base-link>
        <button
            type="button"
            (click)="modal.hide()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="formGroup" novalidate>
        <div class="modal-body no-footer">
            <plan-highlight
                [featureFlags]="currencyFeatureFlag"
            ></plan-highlight>
            <enhanced-help componentName="screen" [compact]="true">
            </enhanced-help>
            <div class="horizontal-container left-buffer">
                <div class="fcol-3 left-buffer">
                    <label [ngClass]="{ readonly: working }">
                        Pilot for Preview
                    </label>
                    <ng-select
                        [searchFn]="personSearch"
                        [(ngModel)]="selectedPilotId"
                        bindValue="id"
                        placeholder="Select a Pilot"
                        [items]="pilots"
                        [ngModelOptions]="{ standalone: true }"
                        [readonly]="working"
                        [loading]="loadingPilots"
                        [virtualScroll]="true"
                        [clearable]="true"
                        appendTo="body"
                        (ngModelChange)="refreshCurrency()"
                        (scrollToEnd)="onPilotSelectScroll()"
                        (search)="onPilotSelectSearch($event)"
                        (close)="onPilotSelectClose()"
                    >
                        <ng-template ng-option-tmp let-item="item">
                            {{ item | formatPerson: true }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            {{ item | formatPerson: true }}
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="table-container side-sheet-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th
                                style="width: 10%"
                                tooltip="Preview"
                                placement="top"
                                enhancedHelp="preview-column"
                                [enhancedHelpOptional]="true"
                            >
                                Preview
                            </th>
                            <th
                                style="width: 30%"
                                tooltip="Currency Conditions"
                                placement="top"
                                enhancedHelp="currency-conditions-column"
                                [enhancedHelpOptional]="true"
                            >
                                Currency Conditions
                            </th>
                            <th
                                style="width: 30%"
                                tooltip="Eligible Flight Conditions"
                                placement="top"
                                enhancedHelp="eligible-flight-conditions-column"
                                [enhancedHelpOptional]="true"
                            >
                                Eligible Flight Conditions
                            </th>
                            <th
                                tooltip="Currency Requirements"
                                placement="top"
                                enhancedHelp="currency-requirements-column"
                                [enhancedHelpOptional]="true"
                            >
                                Currency Requirements
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody formGroupName="edit">
                        <tr
                            *ngFor="
                                let config of currencyConfigurations$ | async
                            "
                        >
                            <td>
                                <ng-container *ngIf="currencyPreviewMap[config.id] as result; else noPreview">
                                    <div class="horizontal-container vertical-align">
                                        <span
                                            [ngClass]="result.passed ? 'fa fa-check text-success' : 'fa fa-times text-danger'"
                                            style="margin-right: 6px"
                                        ></span>
                                        <div>
                                            <div>
                                                {{ result.actualFlights }}
                                                flights
                                            </div>
                                            <div>
                                                {{
                                                    result.actualFlightsTimeSeconds
                                                        | formatDuration
                                                        | defaultTo
                                                }}
                                            </div>
                                            <div *ngIf="result.expiryDate">
                                                Expires:
                                                {{ result.expiryDate | date: 'dd MMM yyyy' }}
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #noPreview></ng-template>
                            </td>
                            <td>
                                <ng-container
                                    *ngIf="editingConfig !== config.id"
                                >
                                    <ng-container
                                        *ngFor="
                                            let condition of config.currencyOperatingConditionList;
                                            let lastCondition = last
                                        "
                                    >
                                        <span
                                            *ngFor="
                                                let value of condition.values;
                                                let last = last
                                            "
                                            ><ng-container
                                                *ngIf="
                                                    value.type !== 'RPA_MTOW'
                                                "
                                                >{{
                                                    operatingConditionsValueLookup[
                                                        value.value
                                                    ]
                                                }}</ng-container
                                            >
                                            <ng-container
                                                *ngIf="
                                                    value.type === 'RPA_MTOW'
                                                "
                                                >{{
                                                    value.value | formatMTOW
                                                }}</ng-container
                                            >{{
                                                last && lastCondition
                                                    ? ''
                                                    : ', '
                                            }}</span
                                        >
                                    </ng-container>
                                    <span
                                        *ngIf="
                                            config
                                                .currencyOperatingConditionList
                                                .length === 0
                                        "
                                        >Any</span
                                    >
                                </ng-container>
                                <ng-container
                                    *ngIf="editingConfig === config.id"
                                >
                                    <div
                                        class="input-group"
                                        style="width: 100%"
                                    >
                                        <ng-select
                                            [items]="operatingConditions"
                                            appendTo="body"
                                            bindValue="id"
                                            [clearable]="false"
                                            [groupBy]="typesGroup"
                                            [multiple]="true"
                                            formControlName="currencyOperatingConditionIdList"
                                            placeholder="Select Currency Conditions"
                                            [readonly]="working"
                                            bindLabel="value"
                                        >
                                            <ng-template
                                                ng-template
                                                ng-option-tmp
                                                let-item="item"
                                                let-index="index"
                                            >
                                                {{ item.value }}
                                            </ng-template>
                                            <ng-template
                                                ng-label-tmp
                                                let-item="item"
                                                let-clear="clear"
                                            >
                                                <span
                                                    class="ng-value-icon left"
                                                    (click)="clear(item)"
                                                    aria-hidden="true"
                                                    >x</span
                                                >
                                                <span class="ng-value-label">{{
                                                    item.value
                                                }}</span>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container
                                    *ngIf="editingConfig !== config.id"
                                >
                                    <ng-container
                                        *ngFor="
                                            let condition of config.requiredOperatingConditionList;
                                            let lastCondition = last
                                        "
                                    >
                                        <span
                                            *ngFor="
                                                let value of condition.values;
                                                let last = last
                                            "
                                            ><ng-container
                                                *ngIf="
                                                    value.type !== 'RPA_MTOW'
                                                "
                                                >{{
                                                    operatingConditionsValueLookup[
                                                        value.value
                                                    ]
                                                }}</ng-container
                                            >
                                            <ng-container
                                                *ngIf="
                                                    value.type === 'RPA_MTOW'
                                                "
                                                ><{{
                                                    value.value | formatMTOW
                                                }}</ng-container
                                            >{{
                                                last && lastCondition
                                                    ? ''
                                                    : ', '
                                            }}</span
                                        >
                                    </ng-container>
                                    <span
                                        *ngIf="
                                            config
                                                .requiredOperatingConditionList
                                                .length === 0
                                        "
                                        >Any</span
                                    >
                                </ng-container>
                                <ng-container
                                    *ngIf="editingConfig === config.id"
                                >
                                    <div
                                        class="input-group"
                                        style="width: 100%"
                                    >
                                        <ng-select
                                            [items]="operatingConditions"
                                            appendTo="body"
                                            bindValue="id"
                                            [clearable]="false"
                                            [groupBy]="typesGroup"
                                            [multiple]="true"
                                            formControlName="requiredOperatingConditionIdList"
                                            placeholder="Select Flight Conditions"
                                            [readonly]="working"
                                            bindLabel="value"
                                        >
                                            <ng-template
                                                ng-template
                                                ng-option-tmp
                                                let-item="item"
                                                let-index="index"
                                            >
                                                {{ item.value }}
                                            </ng-template>
                                            <ng-template
                                                ng-label-tmp
                                                let-item="item"
                                                let-clear="clear"
                                            >
                                                <span
                                                    class="ng-value-icon left"
                                                    (click)="clear(item)"
                                                    aria-hidden="true"
                                                    >x</span
                                                >
                                                <span class="ng-value-label">{{
                                                    item.value
                                                }}</span>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </ng-container>
                            </td>
                            <td>
                                <ng-container
                                    *ngIf="editingConfig !== config.id"
                                >
                                    In the last {{ config.days }} days,<br />
                                    at least
                                    {{ config.requiredFlights }} flights,<br />
                                    with
                                    {{
                                        config.requiredFlightTimeSeconds
                                            | formatDuration
                                            | defaultTo
                                    }}
                                    total flight time <br />
                                    across
                                    {{
                                        config.usingThisAuthority
                                            ? 'missions using this authority'
                                            : 'all missions'
                                    }}
                                </ng-container>
                                <ng-container
                                    *ngIf="editingConfig === config.id"
                                >
                                    <div
                                        class="horizontal-container vertical-align"
                                    >
                                        <label
                                            style="
                                                min-width: 20%;
                                                margin-right: 20px;
                                            "
                                            >Days</label
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            formControlName="days"
                                            min="0"
                                        />
                                    </div>
                                    <div
                                        class="horizontal-container vertical-align"
                                    >
                                        <label
                                            style="
                                                min-width: 20%;
                                                margin-right: 20px;
                                            "
                                            ># Flights</label
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            formControlName="requiredFlights"
                                            min="0"
                                        />
                                    </div>
                                    <div
                                        class="horizontal-container vertical-align"
                                    >
                                        <label
                                            style="
                                                min-width: 20%;
                                                margin-right: 20px;
                                            "
                                            >Flight Time</label
                                        >
                                        <duration
                                            formControlName="requiredFlightTimeSeconds"
                                            [showHour]="true"
                                            [showMinute]="true"
                                            [showSecond]="true"
                                            [clearable]="false"
                                        >
                                        </duration>
                                    </div>
                                    <div
                                        class="horizontal-container vertical-align"
                                    >
                                        <label
                                            style="
                                                min-width: 20%;
                                                margin-right: 20px;
                                            "
                                            >Missions Using This
                                            Authority</label
                                        >
                                        <div
                                            class="input-group"
                                            btnRadioGroup
                                            formControlName="usingThisAuthority"
                                        >
                                            <label
                                                class="btn btn-xs btn-pill"
                                                [btnRadio]="true"
                                                [disabled]="working"
                                                >Yes</label
                                            >
                                            <label
                                                class="btn btn-xs btn-pill"
                                                [btnRadio]="false"
                                                [disabled]="working"
                                                >No</label
                                            >
                                        </div>
                                    </div>
                                </ng-container>
                            </td>
                            <td class="actions">
                                <div
                                    class="inline"
                                    *ngIf="editingConfig === config.id"
                                >
                                    <button
                                        class="btn btn-sm btn-primary"
                                        type="button"
                                        (click)="updateConfig(config)"
                                    >
                                        Save
                                    </button>
                                    <button
                                        class="btn btn-sm btn-link"
                                        type="button"
                                        (click)="cancelEditMode(entry)"
                                    >
                                        Cancel
                                    </button>
                                </div>

                                <div
                                    class="inline"
                                    *ngIf="editingConfig !== config?.id"
                                >
                                    <button
                                        class="btn btn-sm btn-tertiary"
                                        *ngIf="config?.id"
                                        (click)="showEditMode(config)"
                                    >
                                        <span class="fal fa-pencil-alt"></span>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-tertiary btn-delete"
                                        *ngIf="config?.id"
                                        (click)="deleteCurrencyConfig(config)"
                                    >
                                        <span class="fal fa-trash-alt"></span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot formGroupName="add">
                        <tr>
                            <td></td>
                            <td>
                                <div class="input-group" style="width: 100%">
                                    <ng-select
                                        [items]="operatingConditions"
                                        bindLabel="value"
                                        bindValue="id"
                                        appendTo="body"
                                        [clearable]="false"
                                        [groupBy]="typesGroup"
                                        [multiple]="true"
                                        formControlName="currencyOperatingConditionIdList"
                                        placeholder="Select Currency Conditions"
                                        [readonly]="working"
                                    >
                                    </ng-select>
                                </div>
                            </td>
                            <td>
                                <div class="input-group" style="width: 100%">
                                    <ng-select
                                        [items]="operatingConditions"
                                        bindLabel="value"
                                        bindValue="id"
                                        appendTo="body"
                                        [clearable]="false"
                                        [groupBy]="typesGroup"
                                        [multiple]="true"
                                        formControlName="requiredOperatingConditionIdList"
                                        placeholder="Select Flight Conditions"
                                        [readonly]="working"
                                    >
                                    </ng-select>
                                </div>
                            </td>
                            <td>
                                <div
                                    class="horizontal-container vertical-align"
                                >
                                    <label
                                        style="
                                            min-width: 20%;
                                            margin-right: 20px;
                                        "
                                        >Days</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        formControlName="days"
                                        min="0"
                                    />
                                </div>
                                <div
                                    class="horizontal-container vertical-align"
                                >
                                    <label
                                        style="
                                            min-width: 20%;
                                            margin-right: 20px;
                                        "
                                        ># Flights</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        formControlName="requiredFlights"
                                        min="0"
                                    />
                                </div>
                                <div
                                    class="horizontal-container vertical-align"
                                >
                                    <label
                                        style="
                                            min-width: 20%;
                                            margin-right: 20px;
                                        "
                                        >Flight Time</label
                                    >
                                    <duration
                                        formControlName="requiredFlightTimeSeconds"
                                        [showHour]="true"
                                        [showMinute]="true"
                                        [showSecond]="true"
                                        [clearable]="false"
                                    >
                                    </duration>
                                </div>
                                <div
                                    class="horizontal-container vertical-align"
                                >
                                    <label
                                        style="
                                            min-width: 20%;
                                            margin-right: 20px;
                                        "
                                        >Missions Using This Authority</label
                                    >
                                    <div
                                        class="input-group"
                                        btnRadioGroup
                                        formControlName="usingThisAuthority"
                                    >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            [btnRadio]="true"
                                            [disabled]="working"
                                            >Yes</label
                                        >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            [btnRadio]="false"
                                            [disabled]="working"
                                            >No</label
                                        >
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    [disabled]="working"
                                    (click)="addConfig()"
                                >
                                    Add
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <loading-indicator [isLoading]="working"></loading-indicator>
            </div>
        </div>
    </form>
</ng-container>
